module.exports = __webpack_public_path__ + "logo-white-header.56f5ff4fcdaacee3ed96.svg";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/theme/images/logo-white-header.svg
// module id = ../../../../../resources/theme/images/logo-white-header.svg
// module chunks = styles